/**
 * The paywall (D165, platform.md §3.2 and §4): the demo is a set of free
 * rooms, the rest is `paid`, and the turn that would cross without an
 * entitlement is refused — in the game's own words.
 *
 * @remarks
 * The words are the pack's because the refusal happens inside the fiction:
 * the player typed `north` and the world declined, and a modal from the
 * platform at that moment is the one thing the vision forbids. The shell
 * renders these lines in the transcript's voice, beside the one button that
 * is the platform's (Buy). What the lines may NOT do is pretend — the
 * content standards' promises law applies: a line that says the door is
 * locked promises a key.
 *
 * @packageDocumentation
 */

import { z } from 'zod';

import { narrativeLineSchema } from './transcript.js';

/** What the game says at the edge of the demo. */
export const paywallSchema = z
	.strictObject({
		/** The lines, in order, when a turn would enter a paid room without an entitlement. */
		narratives: z.array(narrativeLineSchema).min(1).readonly(),
	})
	.readonly();

export type Paywall = z.infer<typeof paywallSchema>;
